const state = {
  listSelectionDetailMap: {
    coordinate: {lat: -33.433804, lng: -70.642358},
    storeId: null
  }
}

const getters = {

}

const mutations = {
  commit_storeGrowthCenterMap (state, arr) {
    state.listSelectionDetailMap.coordinate = arr[1]
    state.listSelectionDetailMap.storeId = arr[0]
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/storeGrowth.js